import { useQuery } from '@tanstack/react-query';
import { getSFLItems } from 'client/api/save-for-later';
import useGlobalConfig from 'client/state/GlobalConfig';
import { ATGSFLGetItemsResponse } from 'common/types/ATGSFLResponse';
import { Product } from 'common/types/search-response';
import { useCallback, useMemo } from 'react';

export const handleSFLData = (SFLItems: string) => {
  const parsedData = JSON.parse(SFLItems);
  const productIDs = parsedData.savedProducts?.map((product: { productId: string }) => product.productId);
  return productIDs;
};

export const useProductSFL = (productList?: Product[]) => {
  const { isLocal } = useGlobalConfig();

  const { data: sflItems } = useQuery({
    queryKey: ['sfl', isLocal],
    queryFn: getSFLItems,
    select: useCallback((d: ATGSFLGetItemsResponse) => d.savedProducts.map((p) => p.productId), []),
    // Enable only if brand is not "veryireland" or the VeryIE header is enabled
    enabled: true,
  });

  return useMemo(() => {
    if (!sflItems?.length || !productList?.length) return {};

    return productList.reduce((map, p) => {
      map[p.product_id] = sflItems.includes(p.product_id.toString());
      return map;
    }, {} as Record<number, boolean>);
  }, [productList, sflItems]);
};
